/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBCLONEREASON = {
    Cloneforupdate: '2',
    Cloneforoverride: '1'
} as const;
export type GHUBCLONEREASON = typeof GHUBCLONEREASON[keyof typeof GHUBCLONEREASON];


export function GHUBCLONEREASONFromJSON(json: any): GHUBCLONEREASON {
    return GHUBCLONEREASONFromJSONTyped(json, false);
}

export function GHUBCLONEREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBCLONEREASON {
    return json as GHUBCLONEREASON;
}

export function GHUBCLONEREASONToJSON(value?: GHUBCLONEREASON | null): any {
    return value as any;
}

